import confetti from 'canvas-confetti'
import Notification from '@/components/Notification'

export default {
  data() {
    return {
      notification: {
        active: false,
        type: '',
        content: ''
      },
      closeDelay: 3500
    }
  },

  components: {
    Notification
  },

  computed: {
    resourceWord() {
      let isSuccess = this.notification.type === 'success'

      return isSuccess ? 'successfully' : `${this.notification.type}:`
    }
  },

  methods: {
    triggerNotification(type, resource, action, fireConfetti) {
      this.notification.active = true
      this.notification.type = type
      this.notification.content = `${resource} ${this.resourceWord} ${action}!`

      if (fireConfetti) {
        this.fireConfetti()
      }

      window.setTimeout(() => {
        this.notification.active = false
        this.notification.type = ''
        this.notification.content = ''
      }, this.closeDelay)
    },

    fireConfetti() {
      const end = Date.now() + 5000

      if (Date.now() < end) {
        requestAnimationFrame(this.frame)
      }
    },

    frame() {
      const colors = ['#ff7a0e', '#f28e3d']

      confetti({
        particleCount: 75,
        angle: 60,
        spread: 50,
        origin: {x: 0},
        colors: colors
      })
      confetti({
        particleCount: 75,
        angle: 120,
        spread: 50,
        origin: {x: 1},
        colors: colors
      })
    }
  }
}
